class GlsHeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.gls-hero-slide'));
    this.dots = Array.from(this.querySelectorAll('.gls-hero-dot'));
    this.prevBtn = this.querySelector('.gls-hero-arrow--prev');
    this.nextBtn = this.querySelector('.gls-hero-arrow--next');
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.loop = this.dataset.loop !== 'false';
    this.speed = parseInt(this.dataset.speed, 10) || 5000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.applyHeight(this.slides[0]);

    if (this.slides.length < 2) {
      if (this.prevBtn) this.prevBtn.hidden = true;
      if (this.nextBtn) this.nextBtn.hidden = true;
      this.dots.forEach((dot) => (dot.hidden = true));
      return;
    }

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index)));

    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.go(this.current - 1);
      if (event.key === 'ArrowRight') this.go(this.current + 1);
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.reducedMotion.addEventListener('change', () => {
      if (this.reducedMotion.matches) {
        this.stop();
      } else {
        this.start();
      }
    });

    this.setupSwipe();

    this.updateEnds();
    this.start();
  }

  setupSwipe() {
    let startX = 0;
    let startY = 0;
    let tracking = false;

    this.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
      },
      { passive: true }
    );

    this.addEventListener(
      'touchend',
      (event) => {
        if (!tracking) return;
        tracking = false;
        const endX = event.changedTouches[0].clientX;
        const endY = event.changedTouches[0].clientY;
        const deltaX = endX - startX;
        const deltaY = endY - startY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        if (deltaX < 0) {
          this.go(this.current + 1);
        } else {
          this.go(this.current - 1);
        }
      },
      { passive: true }
    );
  }

  applyHeight(slide) {
    if (!slide) return;
    const heightDesktop = slide.dataset.heightDesktop;
    const heightMobile = slide.dataset.heightMobile;
    if (heightDesktop) this.style.setProperty('--gls-hero-h', heightDesktop + 'vh');
    if (heightMobile) this.style.setProperty('--gls-hero-h-mobile', heightMobile + 'vh');
  }

  updateEnds() {
    if (this.loop || !this.prevBtn || !this.nextBtn) return;
    this.prevBtn.toggleAttribute('disabled', this.current === 0);
    this.nextBtn.toggleAttribute('disabled', this.current === this.slides.length - 1);
  }

  go(index) {
    const total = this.slides.length;
    if (this.loop) {
      this.current = (index + total) % total;
    } else {
      this.current = Math.max(0, Math.min(total - 1, index));
    }

    this.slides.forEach((slide, i) => {
      const active = i === this.current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.dots.forEach((dot, i) => {
      const active = i === this.current;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    this.applyHeight(this.slides[this.current]);
    this.updateEnds();
  }

  start() {
    if (!this.autoplay || this.reducedMotion.matches || this.slides.length < 2) return;
    this.stop();
    this.timer = setInterval(() => {
      if (!this.loop && this.current === this.slides.length - 1) {
        this.go(0);
        return;
      }
      this.go(this.current + 1);
    }, this.speed);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }
}

customElements.define('gls-hero-slideshow', GlsHeroSlideshow);
